import { IconProps } from "../../utils/global-types/global-types";

const SimpleDocumentIcon = ({ className, ...rest }: IconProps) => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      fill="none"
      viewBox="0 0 25 25"
      className={className ? className : "w-[25px] h-[25px]"}
      {...rest}
    >
      <path
        fill="#fff"
        stroke="#D0D5DD"
        strokeWidth="0.9"
        d="M5.467 1.34h9.6c.072 0 .143.028.194.08l6.476 6.475c.051.051.08.121.08.194v14.4a1.95 1.95 0 0 1-1.95 1.95h-14.4a1.95 1.95 0 0 1-1.95-1.95v-19.2a1.95 1.95 0 0 1 1.95-1.95Z"
      ></path>
      <path
        stroke="#D0D5DD"
        strokeWidth="0.9"
        d="M15.067 1.189v4.5a2.4 2.4 0 0 0 2.4 2.4h4.5"
      ></path>
      <g clipPath="url(#clip0_3803_21147)">
        <path
          stroke="#155EEF"
          strokeLinecap="round"
          strokeLinejoin="round"
          strokeWidth="0.9"
          d="M7.807 12.589h9.72m-9.72 2.16h9.72m-9.72 2.16h9.72m-9.72 2.16h7.56"
        ></path>
      </g>
      <defs>
        <clipPath id="clip0_3803_21147">
          <path fill="#fff" d="M7.267 9.889h10.8v10.8h-10.8z"></path>
        </clipPath>
      </defs>
    </svg>
  );
};

export default SimpleDocumentIcon;
